import { type ReactNode } from 'react';
import styled from 'styled-components';

import { Vertical } from '#src/atoms/layout/flex/index.tsx';

const Root = styled(Vertical)`
  position: relative;
  z-index: 1;
  padding: 0 var(--double-unit) var(--quadruple-unit);
  gap: var(--double-unit);
  width: 100%;
`;

const Placeholder = styled.div`
  height: 40px;
`;

type Props = {
  primaryAction: ReactNode;
  secondaryAction?: ReactNode;
};

export const BottomActions = ({ primaryAction, secondaryAction }: Props) => (
  <Root>
    {primaryAction}
    {secondaryAction ?? <Placeholder />}
  </Root>
);
